export default __webpack_public_path__ + "static/media/writers-dilemma.c312f485.png";